<template>
  <van-form @submit="onSubmit">
    <h3 class="card-edit-section-title section-title">
      {{ $t("classroom information") }}
    </h3>
    <van-field
      v-model="name"
      name="name"
      :label="$t('name')"
      :placeholder="$t('input classroom name')"
      :rules="[{ required: true, message: $t('classroom name is required') }]"
    />
    <van-field
      v-model="invite"
      center
      clearable
      :label="$t('invite')"
      :placeholder="$t('enter email')"
    >
      <template #button>
        <div class="addInvite-btn" @click="addInvite">
          {{ $t("add") }}
        </div>
      </template>
    </van-field>
    <div style="margin: 16px;" v-if="invites.length > 0">
      <van-tag
        v-for="(inv, index) in invites"
        :key="index"
        closeable
        class="email-tags"
        size="medium"
        type="primary"
        @close="deleteInvite(index)"
      >
        {{ inv }}
      </van-tag>
    </div>
    <van-divider style="margin-left:16px" v-if="invites.length > 0" />
    <van-field name="uploader" :label="$t('image')">
      <template #input>
        <van-uploader v-model="uploader" :multiple="false" :max-count="1" />
      </template>
    </van-field>
    <van-field name="switch" :label="$t('is public')">
      <template #input>
        <van-switch v-model="isPublic" size="20" />
      </template>
    </van-field>
    <div style="margin: 16px; display:flex">
      <van-button
        round
        block
        type="info"
        native-type="save"
        :loading="submitting"
      >
        {{ $t("submit") }}
      </van-button>
    </div>
  </van-form>
</template>

<script>
import { mapActions } from "vuex";
import emailValidation from "@/helpers/emailValidation";
export default {
  name: "ClassroomDetailsForm",
  props: {
    classroom: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      name: "",
      submitting: false,
      isPublic: false,
      uploader: [],
      invite: "",
      invites: [],
      currentMembers: []
    };
  },
  watch: {
    classroom() {
      this.boundForm();
    }
  },
  methods: {
    ...mapActions("vokabel", ["editClassroom", "createNewClassroom"]),
    resetForm() {
      this.name = "";
      this.isPublic = false;
      this.uploader = [];
      this.invite = "";
      this.invites = [];
      this.currentMembers = [];
    },
    boundForm() {
      this.resetForm();
      const { classroom } = this;
      if (classroom) {
        this.name = classroom.name;
        this.isPublic = classroom.public;
        if (classroom.data && classroom.data.image) {
          this.uploader = [
            {
              url: `https://f002.backblazeb2.com/file/sprkr-user-uploads/${classroom.data.image}`
            }
          ];
        }
        this.currentMembers = classroom.members_list.map(
          member => member.email
        );
        this.addInviteToList(classroom.invite_list);
      }
    },
    deleteInvite(index) {
      this.invites = this.invites.filter((item, i) => index != i);
    },
    addInvite() {
      const splitcomma = this.invite.split(",");
      this.addInviteToList(splitcomma);
    },
    addInviteToList(emails) {
      let invites = emails.reduce((accu, email) => {
        if (emailValidation(email)) {
          accu.push(email);
        }
        return accu;
      }, []);
      invites = this.invites.concat(invites);
      // remove duplicates if any
      this.invites = invites.filter((item, index) => {
        return (
          invites.indexOf(item) == index ||
          this.currentMembers.indexOf(item) == -1
        );
      });
      this.invite = "";
    },
    onSubmit() {
      if (this.classroom) {
        this.submitEdit();
      } else {
        this.submitNew();
      }
    },
    setupFormData() {
      this.submitting = true;
      const { isPublic, name, uploader, invites } = this;
      // let formData = { name, public: isPublic, invite_list: invites };

      let formData = new FormData();
      formData.append("name", name);
      formData.append("public", isPublic);
      if (invites && invites.length > 0) {
        formData.append("invite_list", JSON.stringify(invites));
      }
      if (uploader.length > 0 && uploader[0].content) {
        formData.append("image_upload", uploader[0].file);
      }
      return formData;
    },
    submitEdit() {
      let formData = this.setupFormData();
      this.editClassroom({ id: this.classroom.id, formData }).then(() => {
        this.submitting = false;
        this.$emit("closeEdit");
        this.resetForm();
      });
    },
    submitNew() {
      let formData = this.setupFormData();
      this.createNewClassroom(formData).then(classroom => {
        this.submmitting = false;
        this.$emit("closeEdit");
        this.resetForm();
        this.$router.push({ name: "classroom", params: { id: classroom.id } });
      });
    }
  },
  mounted() {
    if (this.classroom) {
      this.boundForm();
    }
  }
};
</script>

<style lang="scss">
.email-tags {
  margin-right: 2.5px;
  margin-bottom: 2.5px;
}
.addInvite-btn {
  color: #fff;
  background-color: #07c160;
  border: 1px solid #07c160;
  font-size: small;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
}
</style>
